import React, { SyntheticEvent } from 'react';
import AudioControl from '../../../common/components/AudioControl';
import AudioControlPlayButton from '../../../common/components/AudioControlPlayButton';
import AudioControlSeekbar from '../../../common/components/AudioControlSeekbar';
import { MusicEntity } from '../../types/MusicEntityTypes';

export default function MusicListItemView({
  music,
  onEdit,
  onEditPermissionToUse,
} : {
  music: MusicEntity,
  onEdit: () => void,
  onEditPermissionToUse: () => void,

}) {
  const cancelEvent = (e: SyntheticEvent) => {
    e.preventDefault();
    e.stopPropagation();
  };

  return (
    <div className="song_one">
      <div className="inner">
        <AudioControl url={music.source_audio_url}>
          <AudioControlPlayButton />
          <div className="song_info">
            <p className="song_title">
              <span className="ttl">{music.title}</span>
              {music.version}
            </p>
            <AudioControlSeekbar />
          </div>
        </AudioControl>
        <div className="right_bt_area">
          <a href="/" onClick={(e) => { cancelEvent(e); onEdit(); }}>
            <img src="/img/music/edit_bt.svg" alt="編集" className="edit" title="編集する" />
          </a>
          {music.allow_use ? (
            <a href="/" onClick={(e) => { cancelEvent(e); onEditPermissionToUse(); }}>
              <img src="/img/music/license_bt.svg" alt="許可" className="license" title="許可する" />
            </a>
          ) : (
            <a href="/" onClick={(e) => { cancelEvent(e); onEditPermissionToUse(); }}>
              <img src="/img/music/license_bt_not.svg" alt="未許可" className="license_not" title="未許可" />
            </a>
          )}
        </div>
      </div>
    </div>
  );
}
